import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { PaymentAPI } from '../../services/paymentAPI';
import { UserMessageService } from '../../services/userMessageService';
import moment from 'moment';

@inject(Router, AuthService, PaymentAPI, UserMessageService)

export class TrialExpired {
    constructor(router, authService, api, userMessageService) {
        this.router = router;
        this.authService = authService;
        this.api = api;
        this.userMessageService = userMessageService;
        this.loading = false;

        this.subscriptionType = "ANNUAL";

        this.annualRenewDate = '';
        this.monthlyRenewDate = '';
        this.beforeSubType = null;

        this.app_name = window.whitelabel ? window.app_name : "Magnfi";
        this.whitelabel = window.whitelabel ? true : false;
        this.sub_error = this.authService.getSubError();
        this.authService.setSubError(null);
    }

    activate() {
        switch (parseInt(this.authService.getAccount().status)) {
            case 2: //Active
                if(this.sub_error)
                    this.type = "sub_error";
                else
                    this.type = "update";
                break;
            case 3: //Suspended
                this.type = "suspended";
                break;
            default: //All Others
                    this.type = "subscribe";
        }

        this.subscriptionType = this.authService.getAccount().subscription_type;
       this.plus_free_trial_used = this.authService.getAccount().plus_free_trial_used;
       this.is_yearly_plus_subscription = this.authService.getAccount().is_yearly_plus_subscription;


        switch (this.authService.getAccount().subscription_type) {
            case "ANNUAL":
                this.currentSubType = "Annual";
                break;
            case "MONTHLY":
                this.currentSubType = "Monthly";
                break;
            case "PLUSTRIAL":
                this.subscriptionType = "PLUS";
            case "PLUS":
              if(this.is_yearly_plus_subscription){
                this.currentSubType = this.app_name + " Plus (Annually)";
                this.subscriptionType = "PLUSYEARLY";
              }
              else{
                this.currentSubType = this.app_name + " Plus (Monthly)";
                this.subscriptionType = "PLUS";
              }



                break;
            default:
                this.currentSubType = "Pay Per Video";
                this.subscriptionType = '';
                break;

        }

        this.beforeSubType = this.subscriptionType;


        var today = new Date();
        this.annualRenewDate = moment(new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())).format('M/D/YYYY');
        this.monthlyRenewDate = moment(new Date(today.getFullYear(), today.getMonth() + 1, today.getDate())).format('M/D/YYYY');
        this.yearlyRenewDate = moment(new Date(today.getFullYear()+1, today.getMonth(), today.getDate())).format('M/D/YYYY');
        this.plusFreeEndDate = moment(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 8)).format('M/D/YYYY');



    }

    attached() {

        this.loading = true;
        this.api.getSubscriptionFee(this.authService.getUser().token, this.subscriptionFeeSuccess.bind(this), this.apiError.bind(this));
     
       setTimeout(function(){

       }.bind(this),2000) 

    }

    subscriptionFeeSuccess(fee) {
        this.subscriptionFee = fee;
        if( ("PLUS".localeCompare(this.authService.getAccount().subscription_type) == 0)  && this.authService.getAccount().is_old_user){
            console.log('OLD User ...');
            this.subscriptionFee.plusFee = fee.plusFeeOld;
        }

        this.api.getPublicApiKey(this.authService.getUser().token, this.apiKeySuccess.bind(this), this.apiError.bind(this));
    }

    apiKeySuccess(key) {
        this.renderStripe(key);

        this.api.getPaymentData(this.authService.getUser().token, this.apiPaymentDataSuccess.bind(this), this.apiError.bind(this));
   }


    apiError(msg) {
        this.userMessageService.setUserError("trial", msg);
console.log('-----------------------------------------------------bbbbb------------------------')
        this.loading = false;
    }

    apiPaymentDataSuccess(last4) {
        this.last4 = last4;

        this.loading = false;

     console.log(this.last4 , this.beforeSubType, this.subscriptionType);

    }

    validate() {
        if(this.subscriptionType == null) {
            return false;
        }

        return true;
    }


    submit() {

        if(!this.validate()) {
            this.userMessageService.setUserError("trial", "Please select a plan.");
            return;
        }


        if(this.subscriptionType) {
            if(this.authService.getAccount().subscription_type != this.subscriptionType && this.type != "subscribe") {
                if (!confirm("Are you sure you want to change your plan?")) {
                    return;
                }
            }
            if(!this.last4) {
                this.stripe.createToken(this.card, { name: this.cardholderName }).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error

                        this.displayError.textContent = result.error.message;
                    } else {
                        // Send the token to your server
                        this.processPayment(result.token.id, this.subscriptionType);
                    }
                }.bind(this));
            }
            else {
                this.processPayment(null, this.subscriptionType);
            }
        } else {
            this.convertToPPV();
        }



    }

    processPayment(token, subType) {
        this.loading = true;
        var data = {
            "account_owner_user_id": this.authService.getAccount().owner_user_id,
            "payment_token": token,
            "subscription_type": subType
        };

        this.api.processSubscriptionPayment(data, this.authService.getUser().token, this.paymentSuccess.bind(this), this.apiError.bind(this));

    }

    paymentSuccess(account) {

        this.authService.setAccount(account);

        // this.userMessageService.setUserMessage("trial", "Thank you for your purchase!");
        console.log("payment success");
        this.loading = false;
        if (account.logo_file == null)
            this.router.navigate('#/user/orgInfo');
        else
            this.router.navigate('#/user');

        console.log("payment success 1");


    }

    convertToPPV() {

        if(confirm("Are you sure you want to convert to Pay-Per-Video?")) {

        this.api.convertToPayPerVideo(
            this.authService.getUser().token,
            (data) => {
                this.authService.setAccount(data);
                this.userMessageService.setUserMessage("trial", "Conversion Successful!");
                this.router.navigate('#/user');
            },
            this.apiError.bind(this));
        }

    }



    renderStripe(key) {
        // Create a Stripe client
        this.stripe = Stripe(key);

        // Create an instance of Elements
        this.elements = this.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '24px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element
        this.card = this.elements.create('card'/*, { style: style }*/);

        // Add an instance of the card Element into the `card-element` <div>
        this.card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        this.card.addEventListener('change', function (event) {

            if (event.error) {
                this.displayError.textContent = event.error.message;
            } else {
                this.displayError.textContent = '';
            }
        }.bind(this));
    }
}
